// Actions for the trigger-time fact-conflict modal. A single pending conflict is
// held at a time: raised by the factsheet-contradiction middleware when a user set
// would newly contradict another fact, cleared when the user resolves it — either
// by confirming (the middleware's held action is replayed) or cancelling (nothing
// was applied, so nothing is undone).

/**
 * @param {Object} conflict
 * @param {Array<{ existing: string, added: string }>} conflict.pairs introduced
 *   conflicts (each pair's `added` names the just-set fact/attribute)
 * @param {{ type: string, payload: Object }} conflict.pendingAction the held set
 *   action to replay verbatim if the user confirms ("Add anyway")
 */
const showFactConflict = (conflict) => ({
  type: 'SHOW_FACT_CONFLICT',
  payload: conflict,
})

const clearFactConflict = () => ({
  type: 'CLEAR_FACT_CONFLICT',
})

export const factConflictActions = {
  showFactConflict,
  clearFactConflict,
}
